import { useEffect, useState } from 'react';
import axios from 'axios';
import { ENDPOINTS } from '../../../Utils/Endpoints';
import { Models } from '../../../Utils/ModelsCarBooking';

const EMPTY = {
  idTipoVehiculo: 0,
  placa: '',
  marca: '',
  modelo: '',
  anio: '',
  color: '',
  capacidad: '',
  activo: true,
};

// catálogo de tipos de vehículo
const endpointTipoVehiculo = ENDPOINTS.catTipoVehiculo;
const modeloTipoVehiculo = Models.tipoVehiculo;

export default function Modal({
  open,
  mode = 'new',
  data = null,
  onClose,
  onSubmit,
  inline = false,
}) {
  const [form, setForm] = useState(EMPTY);
  const [errors, setErrors] = useState({
    idTipoVehiculo: '',
    placa: '',
    marca: '',
    modelo: '',
    anio: '',
    color: '',
    capacidad: '',
  });

  const [tipos, setTipos] = useState([]);
  const [loadingTipos, setLoadingTipos] = useState(false);
  const [errorTipos, setErrorTipos] = useState(null);

  const validateField = (field, rawValue) => {
    const value = typeof rawValue === 'string' ? rawValue.trim() : rawValue;
    let error = '';

    switch (field) {
      case 'idTipoVehiculo':
        if (!value || Number(value) <= 0) error = 'Selecciona un tipo de vehículo.';
        break;
      case 'placa':
        if (!value) error = 'La placa es obligatoria.';
        break;
      case 'marca':
        if (!value) error = 'La marca es obligatoria.';
        break;
      case 'modelo':
        if (!value) error = 'El modelo es obligatorio.';
        break;
      case 'anio':
        if (!value || Number(value) < 1900 || Number(value) > 3000) error = 'El año debe ser válido (1900-3000).';
        break;
      case 'color':
        if (!value) error = 'El color es obligatorio.';
        break;
      case 'capacidad':
        if (!value || Number(value) <= 0) error = 'La capacidad debe ser mayor a 0.';
        break;
      default:
        break;
    }

    setErrors((prev) => ({ ...prev, [field]: error }));
    return !error;
  };

  const validateAll = () => {
    const fields = ['idTipoVehiculo', 'placa', 'marca', 'modelo', 'anio', 'color', 'capacidad'];
    let isValid = true;
    fields.forEach(f => {
      if (!validateField(f, form[f])) isValid = false;
    });
    return isValid;
  };

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
    validateField(field, value);
  };

  useEffect(() => {
    if (mode === 'edit' && data) {
      const filled = {
        idVehiculo: data.idVehiculo ?? 0,
        idTipoVehiculo: data.idTipoVehiculo ?? 0,
        placa: data.placa ?? '',
        marca: data.marca ?? '',
        modelo: data.modelo ?? '',
        anio: data.anio ?? '',
        color: data.color ?? '',
        capacidad: data.capacidad ?? '',
        activo: !!data.activo,
      };
      setForm(filled);
      validateField('idTipoVehiculo', filled.idTipoVehiculo);
      validateField('placa', filled.placa);
      validateField('marca', filled.marca);
      validateField('modelo', filled.modelo);
      validateField('anio', filled.anio);
      validateField('color', filled.color);
      validateField('capacidad', filled.capacidad);
    } else {
      setForm(EMPTY);
      setErrors({ idTipoVehiculo: '', placa: '', marca: '', modelo: '', anio: '', color: '', capacidad: '' });
    }
  }, [mode, data]);

  // cargar catálogo de tipos cuando se abre el modal
  useEffect(() => {
    if (!open) return;

    let canceled = false;

    async function loadTipos() {
      setLoadingTipos(true);
      setErrorTipos(null);
      try {
        const res = await axios.get(endpointTipoVehiculo);
        const tiposNorm = (res.data || []).map((x) => modeloTipoVehiculo(x));
        if (!canceled) {
          setTipos(tiposNorm);
        }
      } catch (err) {
        console.error('Error cargando tipos de vehículo', err);
        if (!canceled) {
          setErrorTipos('No se pudieron cargar los tipos de vehículo.');
        }
      } finally {
        if (!canceled) {
          setLoadingTipos(false);
        }
      }
    }

    loadTipos();

    return () => {
      canceled = true;
    };
  }, [open]);

  if (!open) return null;

  const hasErrors = Object.values(errors).some((e) => !!e);
  const isSaveDisabled =
    !form.idTipoVehiculo ||
    !form.placa?.trim() ||
    !form.marca?.trim() ||
    !form.modelo?.trim() ||
    !form.anio ||
    !form.color?.trim() ||
    !form.capacidad ||
    hasErrors;

  const errorStyle = {
    color: '#b91c1c',
    fontSize: '.8rem',
    display: 'block',
    marginTop: '4px',
  };

  const Header = (
    <div
      className="roles-topbar"
      style={{
        marginBottom: '0.6rem',
        paddingRight: 16,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: '0 0 auto',
      }}>
      <h3 className="roles-title" style={{ marginRight: 0 }}>
        {mode === 'new' ? 'Nuevo vehículo' : 'Editar vehículo'}
      </h3>
      <button className="roles-btn" onClick={onClose} aria-label="Cerrar">✕</button>
    </div>
  );

  const Body = (
    <div
      style={{
        paddingLeft: '12%',
        paddingRight: 16,
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gap: '0.8rem',
        overflowY: 'auto',
        flex: '1 1 auto',
        minHeight: 0,
      }}>

      {/* Tipo de vehículo (select) */}
      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Tipo de vehículo:</label>
        <br /><br />
        <select
          className={`infoField${errors.idTipoVehiculo ? ' infoField--error' : ''}`}
          value={form.idTipoVehiculo || 0}
          onChange={(e) => handleChange('idTipoVehiculo', Number(e.target.value) || 0)}
        >
          <option value={0} disabled>
            {loadingTipos ? 'Cargando tipos…' : 'Seleccione un tipo…'}
          </option>
          {tipos.map((t) => {
            const id =
              t.idTipoVehiculo ??
              t.id ??
              t.value;
            const label =
              (t.clave && String(t.clave).trim()) ||
              t.nombre ||
              t.descripcion ||
              `Tipo #${id}`;
            return (
              <option key={id} value={Number(id)}>
                {label}
              </option>
            );
          })}
        </select>
        {errors.idTipoVehiculo && <small style={errorStyle}>{errors.idTipoVehiculo}</small>}
        {errorTipos && (
          <p
            style={{
              color: '#b91c1c',
              fontSize: '.8rem',
              marginTop: '.25rem',
            }}
          >
            {errorTipos}
          </p>
        )}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Placa:</label>
        <br /><br />
        <input
          className={`infoField${errors.placa ? ' infoField--error' : ''}`}
          value={form.placa}
          onChange={(e) => handleChange('placa', e.target.value)}
          maxLength={20}
        />
        {errors.placa && <small style={errorStyle}>{errors.placa}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Marca:</label>
        <br /><br />
        <input
          className={`infoField${errors.marca ? ' infoField--error' : ''}`}
          value={form.marca}
          onChange={(e) => handleChange('marca', e.target.value)}
          maxLength={80}
        />
        {errors.marca && <small style={errorStyle}>{errors.marca}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Modelo:</label>
        <br /><br />
        <input
          className={`infoField${errors.modelo ? ' infoField--error' : ''}`}
          value={form.modelo}
          onChange={(e) => handleChange('modelo', e.target.value)}
          maxLength={80}
        />
        {errors.modelo && <small style={errorStyle}>{errors.modelo}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Año:</label>
        <br /><br />
        <input
          className={`infoField${errors.anio ? ' infoField--error' : ''}`}
          type="number"
          min={1900}
          max={3000}
          value={form.anio}
          onChange={(e) => handleChange('anio', e.target.value)}
        />
        {errors.anio && <small style={errorStyle}>{errors.anio}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Color:</label>
        <br /><br />
        <input
          className={`infoField${errors.color ? ' infoField--error' : ''}`}
          value={form.color}
          onChange={(e) => handleChange('color', e.target.value)}
          maxLength={50}
        />
        {errors.color && <small style={errorStyle}>{errors.color}</small>}
      </div>

      <div>
        <label className="roles-title" style={{ fontSize: '.95rem' }}>Capacidad:</label>
        <br /><br />
        <input
          className={`infoField${errors.capacidad ? ' infoField--error' : ''}`}
          type="number"
          step="any"
          value={form.capacidad}
          onChange={(e) => handleChange('capacidad', e.target.value)}
        />
        {errors.capacidad && <small style={errorStyle}>{errors.capacidad}</small>}
      </div>

      {/* Campo "activo" eliminado de la UI; se conserva internamente en form */}
    </div>
  );

  const Footer = (
    <div
      style={{
        display: 'flex',
        justifyContent: 'flex-end',
        gap: '.6rem',
        marginTop: '.8rem',
        paddingRight: 16,
        flex: '0 0 auto',
      }}
    >
      <button className="btn-cancel" onClick={onClose}>Cancelar</button>
      <button
        className="btn-action"
        onClick={() => {
          if (validateAll()) onSubmit(form, mode);
        }}
        disabled={isSaveDisabled}
        style={{
          opacity: isSaveDisabled ? 0.5 : 1,
          cursor: isSaveDisabled ? 'not-allowed' : 'pointer',
        }}
      >
        {mode === 'new' ? 'Guardar' : 'Actualizar'}
      </button>
    </div>
  );

  if (inline) {
    return (
      <div className="roles-inline-card" style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
        {Header}
        {Body}
        {Footer}
      </div>
    );
  }

  return (
    <div
      className="roles-confirm-overlay"
      role="dialog"
      aria-modal="true"
      style={{
        position: 'fixed',
        inset: 0,
        background: 'rgba(15,23,42,.45)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 16,
        zIndex: 1000,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose?.(); }}
    >
      <div
        className="roles-confirm-card"
        style={{
          width: 'min(900px, 96vw)',
          maxHeight: '85vh',
          background: '#fff',
          borderRadius: 12,
          boxShadow: '0 10px 30px rgba(0,0,0,.25)',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        {Header}
        {Body}
        {Footer}
      </div>
    </div>
  );
}
